// extracted by mini-css-extract-plugin
export default {"wrap":"Tp-z","logoContainer":"Up-z","brandImg":"Vp-z","logoImg":"Wp-z","logoButton":"Xp-z"};